import { render, staticRenderFns } from "./EmailModalCMF.vue?vue&type=template&id=1331c0bc&"
import script from "./EmailModalCMF.vue?vue&type=script&lang=js&"
export * from "./EmailModalCMF.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports